const labels = {
    SMALL: 'Small business',
    MID_SIZE: 'Mid-size',
    LARGE: 'Large business',
    OTHER_THAN_SMALL: 'Other than small'
};
/** OD-49: analyst tier and SAM are independent sources; unknowns are absent. */ export function companySizeLabel(tier, sam) {
    const tierLabel = labels[tier ?? ''] ?? '';
    const samLabel = labels[sam ?? ''] ?? '';
    if (tierLabel && samLabel) return `${tierLabel} · SAM: ${samLabel.toLowerCase()}`;
    if (tierLabel) return tierLabel;
    return samLabel ? `${samLabel} (SAM)` : '';
}
